import { FOBookingOptionsListNationalityInterface } from '@modules/front-office/interface/fo-api-interface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: FOBookingOptionsListNationalityInterface[] = [];

export const NationalityListSlice = createSlice({
  name: 'nationalityList',
  initialState,
  reducers: {
    setNationalityList: (
      _state,
      action: PayloadAction<FOBookingOptionsListNationalityInterface[]>,
    ) => {
      return [...action.payload];
    },
    removeNationalityList: () => {
      return initialState;
    },
  },
});

export default NationalityListSlice.reducer;

export const { setNationalityList, removeNationalityList } =
  NationalityListSlice.actions;
